import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { primaryNav } from '@/config/site';
import { useScrolled } from '@/hooks/useScrolled';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import { Logo } from '@/components/layout/Logo';
import { contactHref } from '@/lib/contactLink';
import styles from './Header.module.css';

export function Header() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled();
  const location = useLocation();

  // Close the mobile menu whenever navigation occurs.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Lock body scroll while the mobile menu is open.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <Container className={styles.inner}>
        <Logo />

        <nav
          className={`${styles.nav} ${open ? styles.navOpen : ''}`}
          aria-label="Primary"
        >
          <ul className={styles.navList}>
            {primaryNav.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.to === '/'}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.active : ''}`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className={styles.navCta}>
            <Button to={contactHref({ from: 'header' })} size="md">
              Book a call
            </Button>
          </div>
        </nav>

        <button
          type="button"
          className={styles.toggle}
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`${styles.bar} ${open ? styles.barTop : ''}`} />
          <span className={`${styles.bar} ${open ? styles.barHidden : ''}`} />
          <span className={`${styles.bar} ${open ? styles.barBottom : ''}`} />
        </button>
      </Container>
    </header>
  );
}
